import React from "react";

export default function BellIcons() {
  return (
    <svg
      style={{
        display: "inline-block",
        verticalAlign: "middle",
        flexShrink: 0,
        width: "16px",
        height: "16px",
      }}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 1.5a4.5 4.5 0 00-4.5 4.5v2.25L2 10h12l-1.5-1.75V6A4.5 4.5 0 008 1.5z"
        stroke="var(--tx)"
        strokeWidth="1"
        fill="none"
      ></path>
      <path
        d="M6.5 12a1.5 1.5 0 003 0"
        stroke="var(--tx)"
        strokeWidth="1"
        fill="none"
      ></path>
    </svg>
  );
}
